import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  variant?: 'primary' | 'secondary';
  href?: string;
  target?: string;
  rel?: string;
  onLinkClick?: () => void;
}
const variantClasses: Record<'primary' | 'secondary', string> = {
  primary: 'text-blue-950 bg-amber-500 hover:bg-amber-400 shadow-lg shadow-amber-500/30 border border-amber-600/50',
  secondary: 'text-white bg-blue-700 hover:bg-blue-800 shadow-lg shadow-blue-700/25 border border-blue-700'
};
export function Button({
  children,
  className = '',
  variant = 'primary',
  href,
  target,
  rel,
  onLinkClick,
  ...props
}: ButtonProps) {
  const baseClasses = `inline-flex items-center justify-center px-8 py-4 text-lg font-bold rounded-full transition-colors duration-150 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-500 focus-visible:ring-offset-2 focus-visible:ring-offset-blue-950 ${variantClasses[variant]}`;
  if (href) {
    return <motion.a href={href} target={target} rel={rel ?? (target === '_blank' ? 'noopener noreferrer' : undefined)} onClick={onLinkClick} className={`${baseClasses} ${className}`} whileHover={{
      scale: 1.03
    }} whileTap={{
      scale: 0.97
    }} transition={{
      duration: 0.12,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-47" data-mp="i0jxzq4uqgld">
        {children}
      </motion.a>;
  }
  return <motion.button className={`${baseClasses} ${className}`} whileHover={{
    scale: 1.03
  }} whileTap={{
    scale: 0.97
  }} transition={{
    duration: 0.12,
    ease: [0.23, 1, 0.32, 1]
  }} {...props} data-id="element-48" data-mp="3uigjqbv9e0f9">
      {children}
    </motion.button>;
}